module.exports = __webpack_public_path__ + "img/ak-game.40b35601.png";